(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_vera-isdal-floor-extension"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vera-isdal-floor-choice')) {
    customElements.define('vera-isdal-floor-choice', class extends HTMLElement {
      connectedCallback() {
        const amount = this.querySelector('input[type="number"]');
        const zero = this.querySelector('[data-floor-zero]');
        const sync = () => {
          const selected = this.querySelector('input[type="radio"]:checked');
          const longer = selected?.value === 'Extra Isdal length along the floor';
          amount.disabled = !longer;
          amount.required = longer;
          amount.setAttribute('aria-required', String(longer));
          zero.disabled = !selected || longer;
          if (!longer) amount.value = '';
        };
        this.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', sync));
        this.querySelector('input[type="radio"]').form?.addEventListener('reset', () => queueMicrotask(sync));
        sync();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    // Stock availability is independent of the measurement-validation gate.
  // Keep that gate clickable for missing measurements, but never for sold-out variants.
  const checkoutStockSelector = '.accelerated-checkout-block:has([data-vera-checkout-stock])';
  function checkoutStockUnavailable(block) {
    const form = block.closest('product-form-component');
    const scope = form?.closest('.shopify-section, dialog, product-card');
    const picker = scope?.querySelector(`variant-picker[data-product-id="${form?.dataset.productId}"]`);
    const stock = block.querySelector('[data-vera-checkout-stock]');
    try {
      const variants = JSON.parse(stock?.textContent || '[]');
      const id = form?.querySelector('input[name="id"]')?.value;
      const selected = variants.find((variant) => String(variant.id) === id);
      if (selected) return selected.available === false;
      const resource = picker?.querySelector('script[type="application/json"]');
      if (resource) return JSON.parse(resource.textContent || 'null')?.available === false;
      return variants.length > 0 && variants.every((variant) => variant.available === false);
    } catch {
      return true;
    }
  }
  function syncCheckoutStock() {
    document.querySelectorAll(checkoutStockSelector).forEach((block) => {
      const gate = block.querySelector('.vera-buy-now-gate');
      if (!(gate instanceof HTMLButtonElement)) return;
      const unavailable = checkoutStockUnavailable(block);
      if (gate.disabled !== unavailable) gate.disabled = unavailable;
      const label = unavailable ? gate.dataset.soldOutLabel : gate.dataset.availableLabel;
      if (label && gate.textContent.trim() !== label) gate.textContent = label;
    });
  }
  document.addEventListener('click', (event) => {
    const gate = event.target instanceof Element && event.target.closest('.vera-buy-now-gate');
    const block = gate && gate.closest(checkoutStockSelector);
    if (block && checkoutStockUnavailable(block)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', () => requestAnimationFrame(syncCheckoutStock));
  new MutationObserver(syncCheckoutStock).observe(document.documentElement, {
    subtree: true, childList: true, characterData: true, attributes: true,
    attributeFilter: ['value', 'disabled', 'data-explicit-selection-complete']
  });
  syncCheckoutStock();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vera-isdal-back-extension"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vera-isdal-back-extension')) {
    customElements.define('vera-isdal-back-extension', class extends HTMLElement {
      connectedCallback() {
        const amount = this.querySelector('.vera-isdal-back-extension__amount');
        const input = amount.querySelector('input');
        const sync = () => {
          const longer = this.querySelector('input[type="radio"]:checked')?.value === 'Longer at the back';
          input.disabled = !longer;
          input.required = longer;
          if (!longer) input.value = '';
        };
        this.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', sync));
        this.querySelector('input[type="radio"]').form?.addEventListener('reset', () => queueMicrotask(sync));
        sync();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vera-jacket-length"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vera-jacket-length')) {
    customElements.define('vera-jacket-length', class extends HTMLElement {
      connectedCallback() {
        const amount = this.querySelector('input[type="number"]');
        const zero = this.querySelector('[data-jacket-zero]');
        const total = this.querySelector('[data-jacket-total]');
        const sync = () => {
          const choice = this.querySelector('input[type="radio"]:checked');
          const extra = choice?.value === 'Extra length';
          amount.disabled = !extra;
          amount.required = extra;
          zero.disabled = !choice || extra;
          if (!extra) amount.value = '';
          total.disabled = !choice || (extra && !amount.validity.valid);
          total.value = String(75 + (extra && amount.validity.valid ? Number(amount.value) : 0));
        };
        this.addEventListener('change', sync);
        this.addEventListener('input', sync);
        amount.form?.addEventListener('reset', () => queueMicrotask(sync));
        sync();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
